var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-time"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.formatSecondsTimeHm(_vm.onlineTime)))]),_c('span',[_vm._v(_vm._s(_vm.$t('lang.task.online')))])]),_c('div',[_c('span',[_vm._v(_vm._s(_vm.formatSecondsTime(_vm.callTime)))]),_c('span',[_vm._v(_vm._s(_vm.$t('lang.task.calls')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }